import ApiService from "../../../services/api.service";

const ReportService = {

	getReportItems(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all`, data)
	},
	getReportItems51(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all-not-price`, data)
	},
	getReportItems_5(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all-with-reg-date`, data)
	},
	getReportItems1(depId, data) {
		return ApiService.post(`report/incomes/and/offs/in-term/${depId}`, data)
	},
	getReport31(depId, data) {
		return ApiService.post(`report/incomes/and/offs/in-term-with-deps/${depId}`, data)
	},
	getAverageCheckByUsername(data) {
		return ApiService.post(`report/average-check-by-username`, data)
	},
	getTotalSaleByPeriodAndDepartment(data) {
		return ApiService.post(`report/total-sale-by-period-and-department`, data)
	},
	getSaleItemsWithGroupByUsername(data) {
		return ApiService.post(`report/sale-items-with-group-by-username`, data)
	},
	getCashierUsername(data) {
		return ApiService.post(`report/cashier-username`, data)
	},
	getReportItems2(data) {
		return ApiService.post(`report/remaining/of-items/in-term`, data)
	},
	getReportItemsNew2(data) {
		return ApiService.post(`/report/sales-quarter-report`, data)
	},
	getReportSearch(data) {
		return ApiService.post(`/report/income-report-from-contragents`, data)
	},
	getReportSearch1(data) {
		return ApiService.post(`/report/remaining-off-sales-by-departments`, data)
	},
	getReportItemsNew3(data) {
		return ApiService.post(`/report/remaining-quarter-report`, data)
	},
	getReportItems12(data) {
		return ApiService.post(`/report/remaining/of-items/report-sale-by-currency`, data)
	},
	getReportAverageCheck(data) {
		return ApiService.post(`/report/average-check`, data)
	},
	getReportItems12Test(data) {
		return ApiService.post(`/report/remaining/of-items/report-sale-by-currency-daily`, data)
	},
	getReportItems3(data) {
		return ApiService.post(`report/item/transaction/in-term`, data)
	},
	getReportItems4(data) {
		return ApiService.post(`report/sale-items-with-group`, data)
	},
	getExcelItems(data) {
		return ApiService.post(`report/sale-items-with-excel`, data)
	},
	getExcelItems1(data) {
		return ApiService.post(`report/sale-items-with-excel-not-reg-date`, data)
	},
	getContragent(data) {
		return ApiService.post(`report/sale-items-with-group-with-contragent`, data)
	},
	getReportItems5(data) {
		return ApiService.post(`report/item-remaining-between-date`, data)
	},
	getReportItems6(data) {
		return ApiService.post(`report/write-off-items-with-group`, data)
	},
	getReportKpi(data) {
		return ApiService.post(`report/kpi-report`, data)
	},

	getDifferentDailyReport() {
		return ApiService.get(`/report/item-daily-profit`)
	},
	getDifferentMonthlyReport() {
		return ApiService.get(`/report/item-monthly-profit`)
	},
	getRemainingReport() {
		return ApiService.get(`/report/item-daily-balance`)
	},

	dailySaleSum() {
		return ApiService.get(`/report/item-daily-amount`)
	},
	dailySaleAvgSum() {
		return ApiService.get(`/report/item-avg-daily-amount `)
	},
	dailySaleCount() {
		return ApiService.get(`/report/item-number-of-daily-checks `)
	},
	getPendingDocs() {
		return ApiService.get(`/report/item-pending-document`)
	},
	getRemainingByGroup() {
		return ApiService.get(`/report/item-daily-balance-with-group`)
	},
	getTopEmployees(data) {
		return ApiService.post(`/report/sale-by-cashiers`, data)
	},
	getBalanceLogList(data) {
		return ApiService.post('report/balance-log/list', data)
	},
	getDepGroup(data) {
		return ApiService.get(`/department/list-off-dips`)
	}

}

export default ReportService
